module.exports = __webpack_public_path__ + "static/fonts/ionicons.d535a25.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/view-design/src/styles/common/iconfont/fonts/ionicons.ttf?v=3.0.0
// module id = 551
// module chunks = 8